export class NotFoundError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.defineProperty(this, 'name', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'NotFoundError'
    });
  }
}

export class BadRequestError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.defineProperty(this, 'name', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'BadRequestError'
    });
  }
}

export class ResponseError extends Error {
  constructor(response: Response, msg: string) {
    super(msg);
    Object.defineProperty(this, 'response', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: response
    });
    Object.defineProperty(this, 'name', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'ResponseError'
    });
  }
}

export class UnauthorizedError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.defineProperty(this, 'name', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'UnauthorizedError'
    });
  }
}

export class FetchError extends Error {
  constructor(cause: any, msg: string) {
    super(msg);
    Object.defineProperty(this, 'cause', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cause
    });
    Object.defineProperty(this, 'name', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'FetchError'
    });
  }
}

export class RequiredError extends Error {
  constructor(field: any, msg: string) {
    super(msg);
    Object.defineProperty(this, 'field', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: field
    });
    Object.defineProperty(this, 'name', {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'RequiredError'
    });
  }
}
